// extracted by mini-css-extract-plugin
export var infoItem = "_u3-2";
export var title = "_u3-0";
export var value = "_u3-1";